export default {
  API_HOST: process.env.REACT_APP_API_HOST,
  FEEDBACK_URL: process.env.REACT_APP_FEEDBACK_URL,
};



// WEBPACK FOOTER //
// ./src/config/index.ts